<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="600" persistent @input="closeModal">
      <v-card>
        <DialogCardTitle title=" Смена статуса участника" @close="closeModal" />

        <v-card-text class="pa-6">
          <UITextField
            v-model="comment"
            label="По причине"
            :error-messages="errorMessages.comment"
            @input="$v.comment.$touch()"
          />
        </v-card-text>

        <v-card-actions class="px-6 pt-0 pb-5 d-flex justify-end">
          <v-btn
            outlined color="primary"
            class="px-4 d-flex align-center"
            @click="closeModal"
          >
            <v-icon class="uikit-icon close primary" />
            <span class="pl-3 btn-text">
              Отмена
            </span>
          </v-btn>

          <v-btn
            color="primary"
            class="ml-2 px-4 d-flex align-center"
            :disabled="$v.$invalid"
            @click="save"
          >
            <v-icon :class="$v.$invalid ? 'greylighten1' : 'white'" />
            <span class="btn-text">
              Принять
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { setValidateMessages } from '@/scripts/validation'
import { required } from 'vuelidate/lib/validators'
import UITextField from '@/ui/input/UITextField'
import DialogCardTitle from '@/ui/dialog/DialogCardTitle'

export default {
  components: {
    DialogCardTitle,
    UITextField,
  },

  props: { dialog: Boolean },

  data: () => ({ comment: '' }),

  validations() {
    return { comment: { required } }
  },

  computed: {
    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.$params).forEach((key) => {
        allErrors[key] = setValidateMessages(this.$v[key])
      })

      return allErrors
    },
  },

  methods: {
    save() {
      this.$emit('sendToRevision', this.comment)
    },

    resetModal() {
      this.comment = ''
      this.$v.$reset()
    },

    closeModal() {
      this.$emit('closeModal')
    },
  },

  watch: {
    dialog(val) {
      !val && this.resetModal()
    },
  },
}
</script>
